module.exports = __webpack_public_path__ + "static/media/logo-eBit-NielsenCompany.f4b1cc1a.png";